import { NavBarComponent } from './nav-bar.component';

export default angular
  .module('sfMobile.components.nav-bar', [
    'sfMobile.services.localization',
    'sfMobile.services.router',
    'sfMobile.components.button-header',
  ])
  .component('sfNavBar', NavBarComponent).name;
